export default __webpack_public_path__ + "static/media/doctor6.ccb6b290.jpg";